import { render, staticRenderFns } from "./check-box.vue?vue&type=template&id=94a9a52e&"
import script from "./check-box.vue?vue&type=script&lang=js&"
export * from "./check-box.vue?vue&type=script&lang=js&"
import style0 from "./check-box.vue?vue&type=style&index=0&id=94a9a52e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports